<template>
  <div id="app">
    <router-view />
    <Loading v-if="$store.state.showLoading"></Loading>
  </div>
</template>

<script>
import api from '@/utils/api.js';
export default {
  data() {
    return {
      wids: {
        h: '',
        w: ''
      },
      metaData: [
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=0.32'
        }
      ]
    };
  },
  watch: {
    $route(to, from) {
      const _whitList = ['/chat/chatIndex', '/company/account/setmeal'];
      if (_whitList.indexOf(to.path) === -1) {
        this.$store.commit('setcurMenut', '');
      }
      //需要移动端适配的问题
      const _suoFang = [
        '/',
        '/home/realInfo',
        '/home/realDetail',
        '/user/login',
        '/home/downLoad',
        '/user/register',
        '/person/JobFairsList',
        '/person/JobFairs',
        '/person/corp/corpDetail',
        '/person/positionIndex',
        '/findProject',
        'ProjectDetail',
        '/person/corp',
        '/person/about/1',
        '/hprcwadmin',
        '/hpapp',
        '/txwxface',
        '/hpappface',
        '/ayrcwFace',
        '/hprcFace',
        '/checkAvatar',
        '/person/about/2',
        '/person/corp',
        '/person/eliteTalent',
        '/person/position/jobDetail'
      ]; //不缩放的路由页面
      let _router = '';
      if (to.path.substr(-1) === '/' && to.path !== '/') {
        _router = to.path.substr(0, to.path.length - 1);
      } else {
        _router = to.path;
      }
      if (_suoFang.indexOf(_router) > -1 || _suoFang.indexOf(to.name) > -1) {
        this.metaData = [
          {
            name: 'viewport',
            content: 'width=device-width,initial-scale=1.0'
            //width=device-width,initial-scale=1.0
            //width=950, user-scalable=yes, target-densitydpi=device-dpi
            //width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no
          }
        ];
      } else {
        this.metaData = [
          {
            name: 'viewport',
            content: 'width=device-width, initial-scale=0.38'
          }
        ];
      }
    }
  },
  metaInfo() {
    return {
      meta: this.metaData
    };
  },
  updated() {
    this.$store.commit('clearInter'); //清除定时器
    const that = this;
    if (!localStorage.getItem('uid') || !localStorage.getItem('utype') || !localStorage.getItem('hash')) return;
    const _timer = setInterval(() => {
      const _para = {
        uid: localStorage.getItem('uid'),
        utype: localStorage.getItem('utype'),
        pwd_hash: localStorage.getItem('hash')
      };
      this.$http.post(api.hash, _para).then((res) => {
        // const vtime = localStorage.getItem('time');
        const text = res.success === '2' ? '检测到账号行为异常，请重新登录' : res.success === '0' ? '已退出登录，请重新登录' : '';
        if (res.success !== '1') {
          that.out(text);
        } else {
          if (res.system.title) {
            // this.$notify.info({
            // 	title: '消息',
            // 	duration: 0,
            // 	message: res.system.title
            // });
          }
        }
      });
    }, 60000);
    this.$store.commit('setTimerStauts', _timer);
  },
  mounted() {
    this.$store.state.serverUrl = `https://www.mdrcgx.com/base_images/server.png`;
    this.$store.state.commonUrl = `https://www.mdrcgx.com/base_images/gzh.jpg`;
    // this.$store.state.weixinUrl = `https://v1.junqin.vip/web/resource/img/weixin.jpg`;
    this.$store.state.height = window.innerHeight;
    this.$store.state.width = window.innerWidth;
    this.$store.state.mainWidth = (window.innerWidth - 160) / 1.2; //企业宽度
    this.$store.state.bodyWidth = window.innerWidth / 1.6; //求职者端
    this.$store.state.tableH = window.innerHeight - 350;
    window.addEventListener('resize', (e) => this.pageResize(e));
    if (process.env.NODE_ENV !== 'development') {
      //   this.stest(); //防止F12调试
      //   //禁止右键菜单
      //   document.oncontextmenu = function () {
      //     return false;
      //   };
      //   document.oncontextmenu = new Function('event.returnValue=false');
      //   // 禁止 F12 快捷键
      //   document.onkeydown =
      //     document.onkeyup =
      //     document.onkeypress =
      //       function () {
      //         if (window.event.keyCode == 123) {
      //           window.event.returnValue = false;
      //         }
      //       };
      //   document.onkeydown = () => {
      //     //禁用F12
      //     if (window.event && window.event.keyCode == 123) {
      //       return false;
      //       //禁用ctrl+shift+i,
      //     } else if (window.event.ctrlKey && window.event.shiftKey && window.event.keyCode == 73) {
      //       return false;
      //       //屏蔽Shift+F10
      //     } else if (window.event.shiftKey && window.event.keyCode == 121) {
      //       return false;
      //     }
      //   };
    }
  },
  methods: {
    stest() {
      (() => {
        function block() {
          if (window.outerHeight - window.innerHeight > 200 || window.outerWidth - window.innerWidth > 200) {
            document.body.innerHTML = '检测到非法调试,请关闭后刷新重试!';
          }
          setInterval(() => {
            (function () {
              return false;
            })
              ['constructor']('debugger')
              ['call']();
          }, 50);
        }
        try {
          block();
        } catch (err) {}
      })();
    },
    // 窗口变化
    pageResize() {
      this.wids.h = window.innerHeight;
      this.wids.w = window.innerWidth;
      this.$store.dispatch('windowSize', this.wids);
    },
    out(text) {
      this.$store.commit('clearLocation');
      this.$store.commit('clearInter');
      this.$store.commit('setLogin', false);
      this.$router.push('/');
      this.$store.commit('setPersonStateus', {
        isResumeReg: false //是否新注册简历
      });
      this.$confirm(text, '温馨提示', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {})
        .catch(() => {});
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
}
h1,
h2,
h3,
h4,
h5,
form,
p,
ul,
input {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
  color: #606266;
}

/* 绿色 */
.btnSub {
  background: #00c48a !important;
  border-color: #00c48a !important;
  color: white !important;
}

/* 金黄色 */
.btnGolden {
  background: #e6a23c !important;
  border-color: #e6a23c !important;
  color: white !important;
}

.warning {
  color: #e6a23c;
}

.el-notification {
  right: 42% !important;
}

body {
  margin: 0px;
  padding: 0px;
}

/* 默哀日灰色 */
/* html {
    -webkit-filter: grayscale(.95);
} */

.el-dialog {
  border-radius: 10px !important;
}

.flexElm {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex {
  display: flex;
  align-items: center;
}

.flexStart {
  display: flex;
  align-items: flex-start;
}
.flex-space-between {
  justify-content: space-between;
}
.radius10 {
  border-radius: 10px;
}
.pointer {
  cursor: pointer;
}
.flexCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ellipsis2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.ellipsis3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.ellipsis4 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.ellipsis5 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

.ellipsis7 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
}

.ellipsis9 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 9;
  -webkit-box-orient: vertical;
}

.hideText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #666666;
  max-width: 76%;
}
.margin-top-10 {
  margin-top: 10px;
}
.margin-top-20 {
  margin-top: 20px;
}
.substring {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.hidden {
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical !important;
}
.body_content {
  width: 1200px;
  margin: 0 auto;
}
.white_card {
  background: white;
  padding: 20px;
  border-radius: 8px;
}
.white {
  color: white;
}
.bg_white {
  background: white;
}

a,
a:hover {
  text-decoration: none;
}

li,
ol,
ul {
  list-style: none;
}

p {
  margin: 0px;
}

::-webkit-scrollbar {
  width: 0px;
  height: 8px;
  background-color: #ebeef5;
}

::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #ccc;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  background: rgba(255, 255, 255, 1);
}
@media screen and (max-width: 768px) {
  .body_content {
    width: 99% !important;
  }
}
@media screen and (max-width: 1200px) {
  .body_content {
    width: 99% !important;
  }
}

.font10 {
  font-size: 10px;
}

.font-12 {
  font-size: 12px;
}

.font-14 {
  font-size: 14px;
}

.font-15 {
  font-size: 15px;
}

.font-16 {
  font-size: 16px !important;
}

.font-18 {
  font-size: 18px;
}

.font-24 {
  font-size: 24px;
}

.font-20 {
  font-size: 20px !important;
}

.font-22 {
  font-size: 22px;
}

.font-28 {
  font-size: 28px;
}

.font-30 {
  font-size: 30px;
}

.font32 {
  font-size: 32px !important;
}

.font34 {
  font-size: 34px;
}

.font36 {
  font-size: 36px;
}

.font38 {
  font-size: 38px;
}

.font40 {
  font-size: 40px;
}

.font42 {
  font-size: 42px;
}

.font44 {
  font-size: 44px;
}

.font46 {
  font-size: 46px;
}

.font48 {
  font-size: 48px;
}
.u-3 {
  color: #333;
}
.u-8 {
  color: #888;
}
.u-58 {
  color: #585858;
}
.u-f,
.hover-f:hover {
  color: #fff;
}
.bold {
  font-weight: 700;
}
.marT3 {
  margin-top: 3px;
}

.marT4 {
  margin-top: 4px;
}

.marT5 {
  margin-top: 5px;
}

.marT10 {
  margin-top: 10px;
}
.marT15 {
  margin-top: 15px;
}

.marT20 {
  margin-top: 20px !important;
}

.marT30 {
  margin-top: 30px !important;
}

.marB5 {
  margin-bottom: 5px;
}

.marB16 {
  margin-bottom: 16px;
}

.marB25 {
  margin-bottom: 25px;
}

.padT10 {
  padding-top: 10px;
}

.padT11 {
  padding-top: 11px;
}

.padT15 {
  padding-top: 15px;
}

.padT20 {
  padding-top: 20px;
}

.padT25 {
  padding-top: 25px;
}

.padT50 {
  padding-top: 50px;
}

.padT60 {
  padding-top: 60px;
}

.padT70 {
  padding-top: 70px;
}

.padT80 {
  padding-top: 80px;
}

.padT90 {
  padding-top: 90px;
}

.padT100 {
  padding-top: 100px;
}

.padB20 {
  padding-bottom: 20px;
}

.padB25 {
  padding-bottom: 25px;
}

.padB30 {
  padding-bottom: 30px;
}

.padB40 {
  padding-bottom: 40px;
}

.padB70 {
  padding-bottom: 70px;
}

.marB10 {
  margin-bottom: 10px;
}

.marB20 {
  margin-bottom: 20px;
}

.marB15 {
  margin-bottom: 15px;
}

.marB30 {
  margin-bottom: 30px;
}

.marB40 {
  margin-bottom: 40px;
}

.marB50 {
  margin-bottom: 50px;
}

.padT5 {
  padding-top: 5px;
}

.pad5 {
  padding: 5px;
}

.pad10 {
  padding: 10px;
}

.pad20 {
  padding: 20px;
}

.pad30 {
  padding: 30px;
}

.pad40 {
  padding: 40px;
}

.padLR10 {
  padding: 0 10px;
}

.padL5 {
  padding-left: 5px;
}

.padL10 {
  padding-left: 10px;
}

.padR40 {
  padding-right: 40px;
}

.padL20 {
  padding-left: 20px;
}
.relative {
  position: relative;
}
.marL5 {
  margin-left: 5px;
}

.marL10 {
  margin-left: 10px;
}

.marL20 {
  margin-left: 20px;
}

.marL30 {
  margin-left: 30px;
}

.marL40 {
  margin-left: 40px;
}

.marL50 {
  margin-left: 50px;
}

.marL60 {
  margin-left: 60px;
}

.marL100 {
  margin-left: 100px;
}
.marR5 {
  margin-right: 5px;
}

.marR10 {
  margin-right: 10px;
}

.marR15 {
  margin-right: 15px;
}

.marR20 {
  margin-right: 20px;
}

.marR25 {
  margin-right: 25px;
}

.marR30 {
  margin-right: 30px;
}

.marR50 {
  margin-right: 50px;
}

.letter-2 {
  letter-spacing: 2px;
}
.w50 {
  width: 50%;
}

.w48 {
  width: 48%;
}

.w40 {
  width: 40%;
}

.w10 {
  width: 10%;
}

.w20 {
  width: 20%;
}

.w30 {
  width: 30%;
}

.w65 {
  width: 65%;
}

.w60 {
  width: 60%;
}

.w70 {
  width: 70%;
}

.w75 {
  width: 75%;
}

.w80 {
  width: 80%;
}

.w33 {
  width: 33.3%;
}
.textLeft {
  text-align: left !important;
}

.textRight {
  text-align: right;
}

.textCenter {
  text-align: center !important;
}

/* 默认样式，适用于PC端 */
.pc_show {
  display: block !important;
}
.mobile_show {
  display: block !important;
}

/* 移动端样式 */
@media (max-width: 768px) {
  /* 例如，当屏幕宽度小于或等于768px时认为是移动端 */
  .mobile_hide {
    display: none !important;
  }
}
/* 电脑端 */
@media (min-width: 769px) {
  .pc_hide {
    display: none !important;
  }
}
</style>
